import type { VoidFunctionComponent } from 'react';

import { TreeViewLayout } from '../../shared/TreeViewLayout';
import VendoredPathTreeFilter from '../filters/VendoredPathTreeFilter';
import type { ManuallyAddedDependencyRequestKind } from '../../../../../typings/api';
import type useDependencyModals from '../hooks/useDependencyModals';
import type { DependencyToRemove } from '../modals/RemoveDependency';

import VendoredTableContents from './VendoredTableContents';
import VendoredTableHeader from './VendoredTableHeader';

type Props = {
  revisionLocator: string;
  modals: ReturnType<typeof useDependencyModals>;
  setSelectedDependencyRevisionLocator: (locator: string | null) => void;
  setDependencyToRemove: (dependency: DependencyToRemove | null) => void;
  setDependencyLocatorToOverwrite: (locator: string | null) => void;
  setDependencyLocatorToEdit: (locator: string | null) => void;
  setManualDependencyAddMode: (mode: ManuallyAddedDependencyRequestKind | null) => void;
  setInProgressBuildId: (buildId: number | null) => void;
};

/**
 * Layout component for the vendored dependencies view with tree navigation.
 * Uses TreeViewLayout for tree + table inside.
 */
const VendoredDependenciesLayout: VoidFunctionComponent<Props> = ({
  revisionLocator,
  modals,
  setSelectedDependencyRevisionLocator,
  setDependencyToRemove,
  setDependencyLocatorToOverwrite,
  setDependencyLocatorToEdit,
  setManualDependencyAddMode,
  setInProgressBuildId,
}) => {
  const handleSetSelectedLocator = (locator: string) => {
    setSelectedDependencyRevisionLocator(locator);
  };

  return (
    <TreeViewLayout>
      <TreeViewLayout.TreeView header="Files">
        <VendoredPathTreeFilter revisionLocator={revisionLocator} />
      </TreeViewLayout.TreeView>
      <TreeViewLayout.Table header={<VendoredTableHeader />}>
        <VendoredTableContents
          modals={modals}
          setSelectedDependencyRevisionLocator={handleSetSelectedLocator}
          setDependencyToRemove={setDependencyToRemove}
          setDependencyLocatorToOverwrite={setDependencyLocatorToOverwrite}
          setDependencyLocatorToEdit={setDependencyLocatorToEdit}
          setManualDependencyAddMode={setManualDependencyAddMode}
          setInProgressBuildId={setInProgressBuildId}
        />
      </TreeViewLayout.Table>
    </TreeViewLayout>
  );
};

export default VendoredDependenciesLayout;
